import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Optimalcloud() {
  return (
    <section className="optimal_cloud p-100 tekrevol_dark_bg">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Achieve Optimal Cloud Performance with TekRevol</h2>
            <p>
              Maximize your digital infrastructure's efficiency and security
              with TekRevol's advanced cloud consulting solutions – backed by
              seamless integration and robust performance.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="optimal_cloud_box">
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>40%</h2>
                  <p>
                    Lesser Cloud Operational
                    <br /> Costs
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>55%</h2>
                  <p>
                    Increase in System
                    <br /> Scalability & Flexibility
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>65%</h2>
                  <p>
                    Boost in Developer
                    <br /> Productivity
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>100%</h2>
                  <p>
                    Compliance with Data
                    <br /> Security Standards
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>99%</h2>
                  <p>
                    Service Availability for
                    <br /> Reliable Business Continuity
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discover More Cloud Benefits
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Optimalcloud;
